import { render, staticRenderFns } from "./ColumnTitles.vue?vue&type=template&id=33917c77&scoped=true&"
import script from "./ColumnTitles.vue?vue&type=script&lang=js&"
export * from "./ColumnTitles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33917c77",
  null
  
)

export default component.exports